import React from 'react';
import "./Toggle.css";
import { useContext } from 'react';
import { theamContex } from '../../Context';


function Toggle() {
  const theme = useContext(theamContex);
  const darkMode = theme.state.darkMode;
  const handleClick = ()=>{
    theme.dispatch({type: 'toggle'})
  }
  return (
    <div className="toggle" onClick={handleClick}>
        <span><i class="fa-solid fa-sun"></i></span>
        <span><i class="fa-solid fa-moon"></i></span>
        <div className="t-btn"
        style={
          darkMode?{left:'2px'}:{right: '2px'}
        }
        ></div>
    </div>
  )
}

export default Toggle